module.exports = __webpack_public_path__ + "header-24d140deddacf98a82458442fb403d18.svg";